export const SYSTEM_STRUCTURE_VERSION = 1;

export const SYSTEM_STRUCTURE_DEFINITIONS = [
  {
    id: 'flood',
    name: 'Flood',
    sort_order: 10,
    types: [
      {
        id: 'flood-stage',
        name: 'Stage',
        sort_order: 10,
        deviceTypes: [
          {
            system_type: 'Flood',
            device_type: 'Stage',
            sort_order: 10,
          },
          {
            system_type: 'USGS',
            device_type: 'Monitoring Station',
            sort_order: 20,
          },
        ],
      },
    ],
  },
  {
    id: 'road-closures',
    name: 'Road Closures',
    sort_order: 20,
    types: [
      {
        id: 'road-closures-manual',
        name: 'Manual Road Closure',
        sort_order: 10,
        deviceTypes: [
          {
            system_type: 'RescAlert Devices',
            device_type: 'Manual Road Closure',
            sort_order: 10,
          },
        ],
      },
      {
        id: 'road-closures-flashing-lights',
        name: 'Technology Bridge Flashing Lights',
        sort_order: 20,
        deviceTypes: [
          {
            system_type: 'RescAlert Devices',
            device_type: 'Technology Bridge_Flashing Lights',
            sort_order: 10,
          },
        ],
      },
    ],
  },
  {
    id: 'buoy',
    name: 'Buoy',
    sort_order: 25,
    types: [
      {
        id: 'buoy-marine',
        name: 'Buoy',
        sort_order: 10,
        deviceTypes: [
          {
            system_type: 'RescAlert Devices',
            device_type: 'Buoy Conditions',
            system_display_name: 'Buoy',
            sort_order: 10,
          },
        ],
      },
    ],
  },
  {
    id: 'sirens-giant-voice',
    name: 'Sirens / Giant Voice',
    sort_order: 30,
    types: [
      {
        id: 'sirens-giant-voice-rescalert',
        name: 'RescAlert Devices',
        sort_order: 10,
        deviceTypes: [
          {
            system_type: 'RescAlert Devices',
            device_type: 'Technology Bridge_Siren/Giant Voice',
            sort_order: 10,
          },
        ],
      },
    ],
  },
  {
    id: 'overwatch-vms',
    name: 'Overwatch VMS',
    sort_order: 40,
    types: [
      {
        id: 'overwatch-vms-video-surveillance',
        name: 'Video Surveillance',
        sort_order: 10,
        deviceTypes: [
          {
            system_type: 'Exacq Vision',
            device_type: 'Overwatch VMS',
            sort_order: 10,
          },
        ],
      },
    ],
  },
];
